import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

var router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login'),
      meta: {
        title: '登录',
        notLogin: true
      }
    },
    {
      path: '/home',
      name: 'home',
      component: () => import("@/views/home/Home"),
      meta: {
        title: '学问通名师在线'
      },
    },
    {
      path: '/district',
      name: 'district',
      component: () => import("@/views/district/Index"),
      meta: {
        title: '学问通名师在线',
        district: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!to.meta.title) {
    document.title = to.meta.title;
  }
  if (!to.meta.notLogin) {
    let token = localStorage.getItem('loginToken') || '';
    let timestamp = new Date().getTime();
    let expires = localStorage.getItem('tokenExpires') || 0;
    if (token && expires > timestamp) {
      next()
    } else {
      next({ path: '/login' })
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js